<template>
  <v-row v-if="connection.credential">
    <v-col cols="4">
        <select-certificate
            v-if="$permissions.canModifyCertificate"
            :dataProviderId="dataProviderId"
            v-model="connection.credential.certificateId"
            :readonly="readonly"/>
    </v-col>
      <v-col md="4">
          <v-text-field
              v-model="connection.credential.authority"
              label="Authority URL"
              data-cy="authority-url"
              :rules="rules.authorityUrl"
              :readonly="readonly"
          ></v-text-field>
      </v-col>
      <v-col md="4">
          <v-text-field
              v-model="connection.credential.clientId"
              label="Client Id"
              data-cy="clientid"
              :rules="rules.clientId"
              :readonly="readonly"
          ></v-text-field>
      </v-col>
  </v-row>
</template>
<script lang="ts">
import { Validators } from "@/helpers";
import tooltip from "@/components/tooltip.vue";
import createCertificateDialog from "@/views/certificates/create-edit-certificate.vue";
import selectCertificate from "@/views/certificates/select-or-upload-certificate.vue";
import { ConnectionDto, MsalCredentialsDto } from "@/datahub-api";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    tooltip,
    createCertificateDialog,
    selectCertificate,
  },
})
export default class MsalComponent extends Vue {
  @Prop() dataProviderId: string;
  @Prop() readonly: boolean;
  @Prop() connection: ConnectionDto & { credential: MsalCredentialsDto };

  rules = {
    certificateId: Validators.Required.Guid,
    clientId: Validators.Required.Text,
    authorityUrl: Validators.Required.Text,
  };
}
</script>
